export class UnsupportedBrowserException extends Error {
  constructor(message = 'Unsupported Browser') {
    super(message);
  }
}
